<template>
  <div class="d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <div
        class="preview-add-on-image-wrapper mr-3"
        :style="{
          backgroundImage: `url('${item.thumbnailPresignedUrl}')`,
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }"
      ></div>
      <div class="d-flex flex-column">
        <span class="font-weight-medium">{{ renderAddOnTitle }}</span>
        <span
          v-if="item.addOnOptionList.length"
          class="preview-add-on__options grey--text"
          >{{ `Options: ${renderAddOnOptions}` }}
        </span>
      </div>
    </div>
    <CommonIconButton
      color="primary"
      iconClassName="#fff"
      iconSize="20"
      icon="mdi-plus"
      rounded
      xsmall
      width="40"
      height="40"
      @handleButtonClick="handleAddAddOnItem"
    />
  </div>
</template>

<script>
import CommonIconButton from "../common/CommonIconButton";
import { prepareLocalString } from "../../../helpers/prepareLocalString";
import { capitalizeString } from "../../../helpers/capitalizeString";
import { i18n } from "../../../plugins/i18n";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapGetters, mapMutations } from "vuex";
import { syncUUID } from "../../../helpers/util";
export default {
  name: "PreviewAddOnItem",
  components: { CommonIconButton },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationAddOns",
      "playerRegistrationDetails"
    ]),
    renderAddOnTitle() {
      const { name, priceIntCents } = this.item;
      return `${name} - ${prepareLocalString(priceIntCents / 100)}`;
    },

    renderAddOnOptions() {
      return [
        i18n.tc("player_registration.quantity"),
        ...this.item.addOnOptionList.map(item => capitalizeString(item.title))
      ].join(", ");
    }
  },
  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, [
      "setPlayerRegistrationAddOns"
    ]),
    handleAddAddOnItem() {
      this.setPlayerRegistrationAddOns({
        playerRegistrationAddOns: [
          ...this.playerRegistrationAddOns,
          { ...this.item, id: syncUUID(), isEditMode: true, quantity: 0 }
        ]
      });
    }
  }
};
</script>

<style scoped>
.preview-add-on-image-wrapper {
  width: 40px;
  height: 40px;
}

.preview-add-on-image {
  max-width: 100%;
}

.preview-add-on__options {
  font-size: 12px;
}
</style>
